import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import {
  ReadActivitiesPriceRangeRequestDto,
  ReadActivitiesPriceRangeResponseDto,
} from "./dtos";

export const readActivitiesPriceRanges = async (
  data: ReadActivitiesPriceRangeRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReadActivitiesPriceRangeResponseDto>> => {
  return await http.post<ReadActivitiesPriceRangeResponseDto>(
    `/activities/price-range`,
    {
      ...data,
      _method: "GET",
    },
    { cancelToken }
  );
};
